import { APP_ENV } from '@/common/const/env.const'

export const APP_CONFIG = {
  OPERATOR: 'INNOGY',
  [APP_ENV.development]: {
    API: '',
    SENTRY: ''
  },
  [APP_ENV.production]: {
    API: '',
    SENTRY: 'https://f0e0230ae86141e6bfa2878bdb78a196@error.blue.pl/171'
  }
}
